/**
 * @jest-environment jsdom
 */

test('Async auth action creators');

// import React from 'react';
// import assert from 'assert';
// import configureMockStore from 'redux-mock-store';
// import { changePassword } from '../auth';
// import nock from 'nock';
// import createStore from 'redux/create';
// import { browserHistory } from 'react-router';
// import ApiClient from '../../../helpers/ApiClient';
// const client = new ApiClient();

// //TODO: test isn't testing anything
// const mockStore = configureMockStore();

// describe('testing auth async action creators', function() {

//   beforeEach(() => {
//     const store = createStore(browserHistory, client, mockStore);
//     nock.cleanAll();
//   });

//   it('changePassword', done => {
//     const scope = nock('http://localhost:9000')
//       .post('/api/users/me/pass')
//       .reply(200, { body: { todos: ['do something'] } });

//     const expectedActions = { todos: ['do something'] };
//     const store = mockStore();
//     const test = store.dispatch(changePassword());
//     test.promise.then( action => {
//       console.log('action', action);
//       done();
//     });
//   });
// });
